var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-question-filled',{ref:"icon",attrs:{"width":"16","height":"16","color":"#999ca7"}})}
var staticRenderFns = []

export { render, staticRenderFns }